define('CustomProductCollection.MainAction.Item.View', [
    'SCView',
    'custom_product_collection_main_action_item_view.tpl',
    'Utils',
    'underscore'
], function CustomProductCollectionMainActionItemViewModule(
    SCViewComponent,
    template,
    Utils,
    _
) {
    'use strict';

    var SCView = SCViewComponent.SCView;

    /**
     * Item view in a custom product collection.
     * Handles quantity changes and line addition.
     * @constructor
     * @param {Object} options - View options. Must include: item (Object), model (Backbone.Model, must expose getSelectedChild & productDetailsFields)
     */
    function CustomProductCollectionMainActionItemView(options) {
        SCView.call(this);

        this.options = options || {};
        this.template = template;

        this.attributes = {
            id: 'CustomProductCollectionMainActionItemView',
            'class': 'CustomProductCollection-MainAction-Item-View'
        };
    }

    // Inherit parent instance methods.
    CustomProductCollectionMainActionItemView.prototype = Object.create(SCView.prototype);
    CustomProductCollectionMainActionItemView.prototype.constructor =
        CustomProductCollectionMainActionItemView;

    /**
     * Gets the DOM events for this view.
     * @returns {Object} Event name and handler map.
     */
    CustomProductCollectionMainActionItemView.prototype.getEvents = function getEvents() {
        return {
            'click [data-action="custom-add-to-cart"]': 'addToCart',
            'click [data-action="update-item-quantity"]': 'setQuantity'
        };
    };

    /**
     * Handles click event to update the item quantity field.
     * @param {Event} e - jQuery event
     */
    CustomProductCollectionMainActionItemView.prototype.setQuantity = function setQuantity(e) {
        var value = parseInt(this.$(e.currentTarget).data('value'), 10);
        var $inputQuantity = this.$('[name="quantity-' + this.options.item.internalid + '"]');
        var oldValue = parseInt($inputQuantity.val(), 10);
        var newQuantity = oldValue + value;

        e.preventDefault();

        $inputQuantity.val(newQuantity).trigger('blur');
    };

    /**
     * Handles adding line to cart.
     */
    CustomProductCollectionMainActionItemView.prototype.addToCart = function addToCart() {
        var cartComponent = this.options.model.cartComponent;
        var $inputQuantity = this.$('[name="quantity-' + this.options.item.internalid + '"]');
        var quantityValue = $inputQuantity.val();
        var quantity = quantityValue ? Number(quantityValue) : 1;

        cartComponent
            .addLine({
                line: {
                    quantity: quantity,
                    item: {
                        internalid: this.options.item.internalid
                    }
                }
            })
            .done(function doneAddToCart() {
                cartComponent.triggerAddToCartConfirmation();
            });
    };

    /**
     * Returns the context object for rendering the view template.
     * @returns {Object}
     */
    CustomProductCollectionMainActionItemView.prototype.getContext = function getContext() {
        var itemData = this.options.item;
        var selected = this.options.model.getSelectedChild() === itemData.internalid;
        var productDetailsFields = this.options.model.productDetailsFields;
        var item;
        var imgDetails = itemData.itemimages_detail;
        var mediaUrls = imgDetails && imgDetails.media && imgDetails.media.urls;
        var img = mediaUrls && _.first(mediaUrls).url;
        item = {
            internalid: itemData.internalid,
            name:
                itemData.custitem_cpc_child_name ||
                itemData.storedisplayname2 ||
                itemData.displayname,
            description: itemData.storedetaileddescription,
            onlineCustomerPriceFormatted: itemData.onlinecustomerprice_formatted,

            isPurchasable: itemData.ispurchasable,

            isInStock: itemData.isinstock,
            showOutOfStockMessage: itemData.showoutofstockmessage,
            thumbnail: img,
            showImage: itemData.showImage,
            outOfStockMessage:
                itemData.outofstockmessage2 ||
                itemData.outofstockmessage ||
                Utils.translate('Out of Stock'),

            customProperties: _(productDetailsFields)
                .chain()
                .map(function forEachField(field) {
                    field.value = itemData[field.fieldId];
                    return field;
                })
                .filter(function filterEmptyValues(field) {
                    // &nbsp; is empty for a multiselect field
                    return field && field.value && field.value !== '&nbsp;';
                })
                .value()
        };

        return {
            item: item,
            selected: selected,
            url: itemData._url || itemData.urlcomponent
        };
    };

    // Return the AMD constructor.
    return CustomProductCollectionMainActionItemView;
});
